export default function ReparationPieces() {
  const pieces = [
    {
      title: "Équerres et supports de fixation",
      desc: "Les pièces métalliques qui maintiennent le coffre au mur. En cas de rupture ou de corrosion, le coffre se déforme ou vibre. Nous remplaçons les équerres par des modèles adaptés au poids du coffre et au type de mur (béton, brique, placo).",
    },
    {
      title: "Axe d'enroulement et roulements",
      desc: "L'axe sur lequel s'enroule le tablier. Un roulement usé provoque un bruit de grincement et une surcharge du moteur. Nous remplaçons les roulements et les bagues de calage avec des pièces de même diamètre et épaisseur.",
    },
    {
      title: "Joints d'étanchéité",
      desc: "Les bandes de caoutchouc ou de silicone qui empêchent l'eau de pénétrer dans le coffre. Usés par le soleil et le gel, ils laissent passer l'humidité. Nous remplaçons les joints par des profilés neufs adaptés à la largeur du coffre.",
    },
    {
      title: "Caches et habillages de finition",
      desc: "Les couvercles latéraux et frontaux qui ferment le coffre. Cassés ou décolorés, ils affectent l'esthétique et la protection du mécanisme. Nous proposons des caches de remplacement en aluminium ou PVC aux mêmes dimensions.",
    },
    {
      title: "Butées d'axe et guides d'enroulement",
      desc: "Les pièces qui maintiennent l'axe centré dans le coffre et guident l'enroulement du tablier. Usés, ils provoquent un enroulement désaxé et un frottement. Le remplacement est rapide et préserve le tablier.",
    },
    {
      title: "Coque du coffre (section déformée)",
      desc: "En cas de choc localisé, une section de la coque peut être redressée sans remplacer tout le coffre. Nous utilisons des outils de redressage pour les petites déformations et proposons le remplacement de section pour les cas plus graves.",
    },
  ];

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Réparation des pièces internes du coffre
        </h2>
        <p className="text-brand-text leading-relaxed mb-4">
          Un coffre de volet roulant n'est pas qu'une enveloppe vide. Il contient des pièces mécaniques et de fixation essentielles : les équerres de fixation au mur, l'axe d'enroulement avec ses roulements, les butées de centrage, les joints d'étanchéité, et les caches de finition. Chacune de ces pièces peut s'user, se corroder ou se déformer avec le temps, provoquant des bruits, des vibrations, des fuites ou un mauvais enroulement du tablier.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Lors d'une intervention sur coffre à Strasbourg, notre technicien démonte les caches de finition pour accéder à l'intérieur du caisson. Il inspecte chaque composant : fixation, axe, roulement, joint, butée. Les pièces usées sont remplacées par des pièces neuves de même type, les déformations sont redressées, et les fixations sont renforcées si nécessaire. Tout est remonté avec un contrôle de l'étanchéité et de la stabilité du coffre.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {pieces.map((p, i) => (
            <div key={i} className="bg-brand-light rounded-xl border border-brand-border p-5">
              <h3 className="font-semibold text-brand-blue mb-2 text-sm md:text-base">{p.title}</h3>
              <p className="text-sm text-brand-text leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}